"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMissingBankAccountFields = exports.wouldExceedLinkedAccountNumberLimit = exports.resolveSettlementAccount = exports.normaliseBsb = void 0;
const IDistributionConfig_1 = require("./IDistributionConfig");
const ACCOUNT_NAME_LABEL = "Account name";
const SUBSCRIPTION_BSB_LABEL = "BSB";
const SUBSCRIPTION_ACCOUNT_NUMBER_LABEL = "Account number";
/** Strips non-digits and returns the 000-000 form for a 6-digit BSB; any other input is returned unchanged so a malformed stored value stays visible rather than being hidden or auto-corrected. */
const normaliseBsb = (bsb) => {
    if (bsb === undefined) {
        return undefined;
    }
    const digits = bsb.replace(/\D/g, "");
    return digits.length === 6 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : bsb;
};
exports.normaliseBsb = normaliseBsb;
/** Settlement account values as seen by every consumer — money movement, the settings display, and completeness — resolved once so a linked fund's ABA file, preview, and page always agree. */
const resolveSettlementAccount = (company) => {
    const distributionConfig = company?.distributionConfig;
    const fundraiseConfig = company?.fundraiseConfig;
    const linked = distributionConfig?.linkedToSubscriptionAccount === true;
    return {
        bsb: linked ? (0, exports.normaliseBsb)(fundraiseConfig?.accountBSB) : distributionConfig?.settlementBsb,
        accountNumber: linked ? fundraiseConfig?.accountNumber : distributionConfig?.settlementAccountNumber,
        fiCode: distributionConfig?.fiCode,
        apcaId: distributionConfig?.apcaId,
    };
};
exports.resolveSettlementAccount = resolveSettlementAccount;
/** True when a subscription write, if it lengthened the account number past 9 digits, would silently truncate once ABA generation pads it — the same rule linking itself enforces. */
const wouldExceedLinkedAccountNumberLimit = (accountNumber) => Boolean(accountNumber && accountNumber.length > 9);
exports.wouldExceedLinkedAccountNumberLimit = wouldExceedLinkedAccountNumberLimit;
const isNonEmpty = (value) => Boolean(value && value.trim().length > 0);
const isValidNormalisedBsb = (bsb) => Boolean(bsb && /^\d{3}-\d{3}$/.test(bsb));
const isValidAccountNumber = (accountNumber, min, max) => Boolean(accountNumber && new RegExp(`^\\d{${min},${max}}$`).test(accountNumber));
const isValidFiCode = (value) => Boolean(value && /^[A-Za-z0-9]{2,3}$/.test(value));
const isValidApcaId = (value) => Boolean(value && /^\d{6}$/.test(value));
/** Named missing/malformed fields per purpose, evaluated against the resolved values for the settlement purpose so a linked fund with a complete subscription account reports complete. */
const getMissingBankAccountFields = (purpose, company) => {
    if (purpose === "subscription") {
        const fundraiseConfig = company?.fundraiseConfig;
        const missing = [];
        if (!isNonEmpty(fundraiseConfig?.accountName)) {
            missing.push(ACCOUNT_NAME_LABEL);
        }
        if (!isValidNormalisedBsb((0, exports.normaliseBsb)(fundraiseConfig?.accountBSB))) {
            missing.push(SUBSCRIPTION_BSB_LABEL);
        }
        if (!isValidAccountNumber(fundraiseConfig?.accountNumber, 6, 12)) {
            missing.push(SUBSCRIPTION_ACCOUNT_NUMBER_LABEL);
        }
        return missing;
    }
    const resolved = (0, exports.resolveSettlementAccount)(company);
    const missing = [];
    if (!isValidNormalisedBsb((0, exports.normaliseBsb)(resolved.bsb))) {
        missing.push(IDistributionConfig_1.DISTRIBUTION_SETTINGS_FIELD_LABELS.settlementBsb);
    }
    if (!isValidAccountNumber(resolved.accountNumber, 6, 9)) {
        missing.push(IDistributionConfig_1.DISTRIBUTION_SETTINGS_FIELD_LABELS.settlementAccountNumber);
    }
    if (!isValidFiCode(resolved.fiCode)) {
        missing.push(IDistributionConfig_1.DISTRIBUTION_SETTINGS_FIELD_LABELS.fiCode);
    }
    if (!isValidApcaId(resolved.apcaId)) {
        missing.push(IDistributionConfig_1.DISTRIBUTION_SETTINGS_FIELD_LABELS.apcaId);
    }
    return missing;
};
exports.getMissingBankAccountFields = getMissingBankAccountFields;
//# sourceMappingURL=bankAccounts.js.map